module.exports = __webpack_public_path__ + "static/media/menu-black-24dp.db302a5c.svg";